export const CUISINES = [
  { id: "burgers", ar: "برجر" }, { id: "pizza", ar: "بيتزا" }, { id: "chicken", ar: "دجاج" },
  { id: "arabic", ar: "عربي" }, { id: "mandi", ar: "مندي وكبسة" }, { id: "shawarma", ar: "شاورما" },
  { id: "asian", ar: "آسيوي" }, { id: "indian", ar: "هندي" }, { id: "italian", ar: "إيطالي" },
  { id: "mexican", ar: "مكسيكي" }, { id: "seafood", ar: "بحري" }, { id: "grills", ar: "مشويات" },
  { id: "sandwiches", ar: "ساندوتشات" }, { id: "breakfast", ar: "فطور" }, { id: "healthy", ar: "صحي" },
  { id: "dessert", ar: "حلويات" }, { id: "icecream", ar: "آيس كريم" }, { id: "bakery", ar: "مخبوزات" },
  { id: "coffee", ar: "قهوة" }, { id: "juices", ar: "عصائر" },
  { id: "supermarket", ar: "سوبرماركت" }, { id: "pharmacy", ar: "صيدلية" },
  { id: "beauty", ar: "عناية وتجميل" },
];

export const statusColor = {
  placed: "bg-amber-100 text-amber-800",
  preparing: "bg-blue-100 text-blue-800",
  on_the_way: "bg-indigo-100 text-indigo-800",
  delivered: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
};

export const emptyRestaurant = {
  name_en: "", name_ar: "", cuisine_en: "burgers", cuisine_ar: "برجر",
  image: "", cover_image: "", rating: 4.5,
  delivery_time: "30-45", delivery_fee: 10.0, min_order: 25.0,
  tags: [], cities: [], description_en: "", description_ar: "", menu: [],
};

export const emptyMenuItem = {
  name_en: "", name_ar: "", description_en: "", description_ar: "",
  price: 0, image: "", category: "Main",
};

export const ONLINE_WINDOW_MS = 2 * 60 * 1000;

// Backend serializes UTC datetimes without a timezone suffix; treat them as UTC
export const parseUtc = (iso) => new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);

export const isOnline = (iso) => !!iso && Date.now() - parseUtc(iso).getTime() < ONLINE_WINDOW_MS;

export const lastSeenLabel = (iso) => {
  if (!iso) return "لم يدخل بعد";
  const diff = Date.now() - parseUtc(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (diff < ONLINE_WINDOW_MS) return "متصل الآن";
  if (m < 60) return `منذ ${m} دقيقة`;
  const h = Math.floor(m / 60);
  if (h < 24) return `منذ ${h} ساعة`;
  const d = Math.floor(h / 24);
  if (d < 7) return `منذ ${d} يوم`;
  return parseUtc(iso).toLocaleDateString("ar-SA");
};
